/* Odds Comfort: "Smart picks". On-device behaviour model.
   Tracks views, adds, saves, searches and purchases in localStorage, builds a recency-weighted taste profile
   (department, height, colour family, pattern, pack size, price) and ranks catalog items per context
   (product page, cart, home, search, account). Nothing leaves the browser. */
(function () {
  'use strict';
  var Odds = window.Odds;
  if (!Odds) return;
  var KEY = 'odds:brain:v1';
  var CAP = 300;
  var HALF = 10 * 24 * 3600 * 1000; // taste half-life: 10 days
  var W = { view: 1, add: 3.2, wish: 2.4, buy: 2.8, search: 0.7, coll: 0.5 };
  var enabled = !(Odds.cfg.features && Odds.cfg.features.brain === false);
  var dnt = navigator.doNotTrack === '1' || window.doNotTrack === '1';

  var state = Odds.store.get(KEY, { v: 1, ev: [], purchased: [] });
  if (!state || !state.ev) state = { v: 1, ev: [], purchased: [] };
  function save() { Odds.store.set(KEY, state); }

  var KEYWORDS = {
    dept: { men: ['men', 'man', 'mens', "men's", 'رجالي', 'رجال'], women: ['women', 'woman', 'womens', 'ladies', 'lady', 'girl', 'حريمي', 'نسائي', 'بناتي'], kids: ['kids', 'kid', 'children', 'child', 'boys', 'school', 'أطفال', 'اطفال', 'مدرسة'] },
    cut: { crew: ['crew', 'long', 'tall', 'طويل'], quarter: ['quarter', 'نص'], ankle: ['ankle', 'low', 'كاحل', 'قصير'], noshow: ['noshow', 'no-show', 'invisible', 'hidden', 'مخفي'] },
    fam: { black: ['black', 'أسود', 'اسود'], white: ['white', 'أبيض', 'ابيض'], grey: ['grey', 'gray', 'رمادي'], navy: ['navy', 'blue', 'كحلي', 'ازرق', 'أزرق'], colourful: ['colour', 'color', 'colorful', 'colourful', 'ملون', 'pink', 'rose', 'green', 'وردي'] }
  };
  function decay(t) { return Math.pow(0.5, (Date.now() - t) / HALF); }
  function add(map, k, w) { if (k == null || k === '') return; map[k] = (map[k] || 0) + w; }
  function norm(map) { var m = 0, k; for (k in map) m = Math.max(m, map[k]); if (m > 0) for (k in map) map[k] = map[k] / m; return map; }

  function tokens(q) { return String(q || '').toLowerCase().split(/[\s,]+/).filter(Boolean); }
  function keywordMatch(group, tok) {
    var out = [];
    Object.keys(KEYWORDS[group]).forEach(function (k) { if (KEYWORDS[group][k].indexOf(tok) > -1) out.push(k); });
    return out;
  }

  var Brain = (Odds.brain = {
    enabled: enabled && !dnt,
    track: function (kind, data) {
      if (!Brain.enabled) return;
      var e = { t: Date.now(), k: kind };
      if (data) { if (data.h) e.h = data.h; if (data.q) e.q = String(data.q).slice(0, 60); if (data.c) e.c = data.c; }
      // collapse repeat views of the same product within 20 minutes
      if (kind === 'view') {
        for (var i = state.ev.length - 1; i >= 0 && i > state.ev.length - 8; i--) {
          if (state.ev[i].k === 'view' && state.ev[i].h === e.h && Date.now() - state.ev[i].t < 20 * 60 * 1000) { state.ev[i].t = e.t; save(); return; }
        }
      }
      state.ev.push(e);
      if (state.ev.length > CAP) state.ev = state.ev.slice(-CAP);
      save();
      Odds.emit('brain:event', e);
    },
    setPurchased: function (handles) {
      if (!Brain.enabled || !handles || !handles.length) return;
      var set = {}; (state.purchased || []).concat(handles).forEach(function (h) { set[h] = 1; });
      state.purchased = Object.keys(set);
      // purchases also count as taste events (once per handle)
      var have = {}; state.ev.forEach(function (e) { if (e.k === 'buy') have[e.h] = 1; });
      handles.forEach(function (h) { if (!have[h]) state.ev.push({ t: Date.now() - 86400000, k: 'buy', h: h }); });
      save();
    },
    clear: function () { state = { v: 1, ev: [], purchased: [] }; save(); },
    hasHistory: function () { return state.ev.length > 0; },

    profile: function () {
      var cat = Odds.catalog, P = { dept: {}, cut: {}, pairs: {}, pt: {}, fam: {}, price: 0, priceW: 0, seen: {}, lastView: null, lastT: 0, n: 0 };
      state.ev.forEach(function (e) {
        var w = (W[e.k] || 0.5) * decay(e.t);
        if (e.k === 'search') {
          tokens(e.q).forEach(function (tk) {
            keywordMatch('dept', tk).forEach(function (k) { add(P.dept, k, w); });
            keywordMatch('cut', tk).forEach(function (k) { add(P.cut, k, w); });
            keywordMatch('fam', tk).forEach(function (k) { add(P.fam, k, w); });
          });
          P.n++; return;
        }
        if (e.k === 'coll') {
          tokens((e.c || '').replace(/-/g, ' ')).forEach(function (tk) {
            keywordMatch('dept', tk).forEach(function (k) { add(P.dept, k, w); });
            keywordMatch('cut', tk).forEach(function (k) { add(P.cut, k, w); });
          });
          P.n++; return;
        }
        var p = cat.byHandle[e.h]; if (!p) return;
        P.n++;
        add(P.dept, p.d, w); add(P.cut, p.c, w); add(P.pairs, p.n, w * 0.5); add(P.pt, p.pt, w * 0.6);
        (p.f || []).forEach(function (f) { add(P.fam, f, (w * 1.5) / Math.max(1, p.f.length)); });
        P.price += p.p * w; P.priceW += w;
        P.seen[p.h] = (P.seen[p.h] || 0) + (e.k === 'view' ? 1 : 3);
        if (e.k === 'view' && e.t > P.lastT) { P.lastT = e.t; P.lastView = p.h; }
      });
      (state.purchased || []).forEach(function (h) { P.seen[h] = (P.seen[h] || 0) + 3; });
      norm(P.dept); norm(P.cut); norm(P.pairs); norm(P.pt); norm(P.fam);
      P.meanPrice = P.priceW ? P.price / P.priceW : 0;
      return P;
    },

    /* viewed products, most recent first, unique */
    recent: function (n, exclude) {
      var seen = {}, out = [];
      for (var i = state.ev.length - 1; i >= 0 && out.length < (n || 8); i--) {
        var e = state.ev[i];
        if (e.k !== 'view' || seen[e.h] || (exclude && exclude.indexOf(e.h) > -1)) continue;
        seen[e.h] = 1;
        var p = Odds.catalog.byHandle[e.h]; if (p) out.push(p);
      }
      return out;
    },

    /* the ranking function */
    recommend: function (opts) {
      opts = opts || {};
      var cat = Odds.catalog, P = Brain.profile(), now = new Date();
      var cartSet = {}; (opts.cartHandles || []).forEach(function (h) { cartSet[h] = 1; });
      var excl = {}; (opts.exclude || []).forEach(function (h) { excl[h] = 1; });
      var ctx = opts.context || 'home';
      var cur = opts.product ? cat.byHandle[opts.product] : null;
      var curated = opts.curated || [];
      var cartItems = (opts.cartHandles || []).map(function (h) { return cat.byHandle[h]; }).filter(Boolean);
      var cartCuts = {}, cartDept = {};
      cartItems.forEach(function (p) { cartCuts[p.c] = 1; cartDept[p.d] = (cartDept[p.d] || 0) + 1; });
      var cartMainDept = null, max = 0; Object.keys(cartDept).forEach(function (d) { if (cartDept[d] > max) { max = cartDept[d]; cartMainDept = d; } });
      var gap = opts.gap || 0;
      var cold = !Brain.hasHistory();

      function famOverlap(a, b) { var c = 0; (a.f || []).forEach(function (f) { if ((b.f || []).indexOf(f) > -1) c++; }); return Math.min(1, c / Math.max(1, Math.min((a.f || []).length, (b.f || []).length))); }
      function personal(p) {
        var s = 2.0 * (P.dept[p.d] || 0) + 1.2 * (P.cut[p.c] || 0) + 0.5 * (P.pt[p.pt] || 0) + 0.4 * (P.pairs[p.n] || 0);
        var fm = 0; (p.f || []).forEach(function (f) { fm = Math.max(fm, P.fam[f] || 0); }); s += 0.8 * fm;
        if (P.meanPrice) s += 0.5 * (1 - Math.min(1, Math.abs(p.p - P.meanPrice) / P.meanPrice));
        return s;
      }

      var scored = cat.items.filter(function (p) { return p.h !== opts.product && !excl[p.h]; }).map(function (p) {
        var s = 0;
        if (!p.a) s -= 10;
        if (cartSet[p.h]) s -= 6;
        if ((state.purchased || []).indexOf(p.h) > -1) s -= 1.2;
        if (cold) {
          // cold start: gentle popularity proxy (catalog order) plus a day-stable shuffle so it does not feel static
          var seed = (now.getDate() * 31 + p.rank * 17) % 11;
          s += (1 - p.rank / Math.max(1, cat.items.length)) * 1.2 + seed * 0.05;
        } else {
          s += personal(p) * (ctx === 'pdp' ? 0.7 : 1);
          var seenC = P.seen[p.h] || 0;
          if (ctx !== 'recent') s -= 0.5 * Math.min(2, seenC);
        }
        if (ctx === 'pdp' && cur) {
          s += p.d === cur.d ? 3 : -4;
          if (p.c !== cur.c) s += 1.5;
          s += 0.9 * famOverlap(cur, p);
          if (p.pt !== cur.pt) s += 0.4;
          s += 0.6 * (1 - Math.min(1, Math.abs(p.p - cur.p) / cur.p));
          if (curated.indexOf(p.h) > -1) s += 1.6;
        }
        if (ctx === 'cart') {
          if (cartMainDept) s += p.d === cartMainDept ? 2.5 : -2;
          if (!cartCuts[p.c]) s += 1.2;
          if (gap > 0) {
            if (p.p >= gap) s += 3.2 * (1 - Math.min(1, (p.p - gap) / gap));
            else s += 0.8 * (p.p / gap);
          } else if (p.n >= 5) s += 0.8;
        }
        if (ctx === 'popup' && cur) {
          s += p.d === cur.d ? 2.5 : -3;
          if (p.c !== cur.c) s += 1.6;
          s += 0.8 * famOverlap(cur, p);
          if (curated.indexOf(p.h) > -1) s += 1.4;
        }
        return { p: p, s: s };
      }).sort(function (a, b) { return b.s - a.s; });

      // MMR-style diversity: do not return five of the same cut and pattern
      var out = [], n = opts.n || 4, pool = scored.slice(0, 24);
      while (out.length < n && pool.length) {
        var bi = 0, bv = -1e9;
        for (var i = 0; i < pool.length; i++) {
          var pen = 0;
          out.forEach(function (o) { if (o.p.c === pool[i].p.c) pen += 0.35; if (o.p.pt === pool[i].p.pt) pen += 0.15; if (o.p.d !== pool[i].p.d) pen += 0.1; });
          var v = pool[i].s - pen;
          if (v > bv) { bv = v; bi = i; }
        }
        out.push(pool.splice(bi, 1)[0]);
      }
      var reason = { key: 'popular_now' };
      if (ctx === 'cart') reason = { key: 'because_cart' };
      else if (ctx === 'pdp' || ctx === 'popup') reason = cur ? { key: 'because_viewed', vars: { title: cur.t } } : reason;
      else if (!cold) {
        var last = P.lastView && cat.byHandle[P.lastView];
        reason = last ? { key: 'because_viewed', vars: { title: last.t } } : { key: 'because_browsing' };
      }
      return { items: out.map(function (o) { return o.p; }), reason: reason, cold: cold };
    }
  });

  /* auto-track collection page views */
  function trackPage() {
    var el = document.querySelector('[data-track-collection]');
    if (el) Brain.track('coll', { c: el.getAttribute('data-track-collection') });
    var sr = document.querySelector('[data-track-search]');
    if (sr && sr.getAttribute('data-track-search')) Brain.track('search', { q: sr.getAttribute('data-track-search') });
  }
  trackPage();
})();
